import {
  LAIS_IMOVEIS_PERMISSIONS,
  laisAliases,
  laisPath,
} from '../laisRouteHelpers';
import CondominiosConsole from './pages/CondominiosConsole.vue';

export const routes = [
  {
    path: laisPath('condominios'),
    alias: laisAliases(
      'condominiums',
      'imoveis/condominios',
      'administracao/condominios'
    ),
    name: 'lais_condominios_index',
    component: CondominiosConsole,
    meta: {
      permissions: LAIS_IMOVEIS_PERMISSIONS,
      runtimeAudit: 'FE-AUD-59',
    },
  },
];
